import React, {
  FC,
} from 'react';
import { FaqTitle, FaqContent, SplitLine, Column } from './Styles';

const EN: FC = () => {
  return (
    <>
      {/* 英文条款 */}
      <div style={{ width: '90%', overflow: 'auto', marginLeft: 'auto', marginRight: 'auto', textAlign: 'left' }}>
        <FaqTitle>
          Earning Foodifox points
        </FaqTitle>
        <FaqContent>
          There are now more ways to earn points! Points can be earned by:
        </FaqContent>
        <FaqContent>
          1. Deliveries - earn up to 5 points for each delivery.
          <br />
          2. Bonus Points  - earn bonus points by participating in promotions or by referring friends.
          <br />
          Points may be deducted from your account if you rent a cubicle, but don’t complete the order.
          <br />
          Foodifox reserves the right to amend any details of the rewards program.
        </FaqContent>
        <FaqContent>
          <b>Note:</b> Foodifox Drop-Off Points are different from Foodifox Cafe Points. Foodifox Drop-Off Points will expire after 1 year, at the end of the equivalent month in which they were earned. This is applicable for all tiers. (E.g. Points earned in a Foodifox account in Nov 2023 will expire on 30 Nov 2024.)
        </FaqContent>

        {/* 分割线 */}
        <Column>
          <SplitLine />
        </Column>

        <FaqTitle>
          Using Foodifox points
        </FaqTitle>
        <FaqContent>
          Your points balance is displayed on Dashboard and the Redeem pages within the Foodifox Drop-Off app. This is the balance available for you to redeem.
          <br />
          You can use the points to redeem rewards through the Foodifox Drop-Off app. Follow the instructions for each of the reward options found on the redeem page.
        </FaqContent>

        {/* 分割线 */}
        <Column>
          <SplitLine />
        </Column>

        <FaqTitle>
          About viewing Foodifox points
        </FaqTitle>
        <FaqContent>
          Please log into your Foodifox account and view the balance on Dashboard or Redeem page.
        </FaqContent>

        {/* 分割线 */}
        <Column>
          <SplitLine />
        </Column>

        <FaqTitle>
          Validity period of Foodifox points
        </FaqTitle>
        <FaqContent>
          Foodifox Points earned will expire after One calendar year at the end of the month in which they were earned. For example points earned in November 2023 will expire in 30th November 2024.
        </FaqContent>

        {/* 分割线 */}
        <Column>
          <SplitLine />
        </Column>

        <FaqTitle>
          Refunding Foodifox points
        </FaqTitle>
        <FaqContent>
          Once you successfully redeemed a reward, the points will be immediately deducted, there is no option to get a refund at this point.
        </FaqContent>
      </div>
    </>
  );
};

export default EN;
